export default __webpack_public_path__ + "static/media/visitor_bg.9f88dfa7.jpg";